import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { createModal, useModalize } from '@/components/modalize/mui'
import { WarningLarge } from '@/components/icons'
import { Button } from '@/components/button'
import { fontWeights, fontSizes, colors, breakpoints } from '@/styles'

// Styled Components
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 0 0 44px 0;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
  }
`

// Top icon section of modal
const Topper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  background: #fcf5d8;
  width: 100%;
  padding: 44px;
`

// Main content section ( text )
const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 44px;
`
const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const Title = styled.div`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  line-height: 32px;
  text-align: center;
`
const Subtitle = styled.div`
  text-align: center;
  color: ${colors.grey24};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    text-align: left;
  }
`

// Bottom action section ( with the buttons & links )
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
  width: 100%;
  font-size: ${fontSizes.small};
  margin-top: 24px;
  padding: 0 44px;
`
const StyledButton = styled(Button)`
  background-color: ${colors.blue16};
  width: 100%;
`

type Props = {
  process: (values: any) => void
  values: any
  onSuccess?: () => void
}

const ConfirmationModal = ({ process, values }: Props) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const { close } = useModalize()

  const handleConfirm = async () => {
    setLoading(true)
    await process(values)
    close()
    setLoading(false)
  }

  return (
    <Wrapper>
      <Topper>
        <WarningLarge />
      </Topper>
      <Main>
        <TitleSection>
          <Title>Are you sure?</Title>
          <Subtitle>
            Turning this on will also replace your current payment method for any active
            subscription plans after you submit your purchase.
          </Subtitle>
        </TitleSection>
      </Main>
      <Actions>
        <StyledButton onClick={close} theme={'secondary'}>
          Cancel
        </StyledButton>
        <StyledButton onClick={handleConfirm} loading={loading}>
          Continue
        </StyledButton>
      </Actions>
    </Wrapper>
  )
}

export const showConfirmationModal = createModal(ConfirmationModal, {
  width: 'auto',
  maxWidth: '550px',
  showBackground: false
})
